import { backendTaskApi } from '../../../api/backendTask';
import { DocumentStatus } from '../../../api/model/document';

export type ExportMethodType =
  | typeof backendTaskApi.startUserDocumentsExportTask
  | typeof backendTaskApi.startAllDocumentsExportTask
  | typeof backendTaskApi.startUserActionableDocumentsExportTask
  | typeof backendTaskApi.startUserTrainingDocumentsExportTask;

export type StatusFilterMapType = {
  [key: string]: {
    label: string;
    statusFilters: (DocumentStatus | string)[] | null;
    isDefault?: boolean;
  };
};

export const ALL_OPEN_STATUSES = 'all_open';
export const FOR_TRAINING_STATUS = 'for_training';
